<template>
  <div>
    <navigation/>
    <div class="pale-bgcolor">
      <div class="ay_contain">
        <div class="ay_title">
          亮照申请<span class="i-sign">（信息正在核对中，暂时无法修改）</span>
        </div>
        <div class="ay_userinfo">
          <div class="ayui_title">
            <span></span>网站所有者情况
          </div>
          <div class="ayui_list">
            <div class="ayui_item">
              <label><i class="i-sign">∗</i> 企业名称 :</label>
              <span class="ayui-span">{{ siteBaseInfo.companyName }}</span>
            </div>
            <div class="ayui_item">
              <label>注册资本 :</label>
              <span class="ayui-span">{{ siteBaseInfo.companyRegisterMoney }}</span>
            </div>
            <div class="ayui_item">
              <label><i class="i-sign">∗</i> 法定代表人 :</label>
              <span class="ayui-span">{{ siteBaseInfo.companyLegalPerson }}</span>
            </div>
            <div class="ayui_item">
              <label>成立日期 :</label>
              <span class="ayui-span">{{ siteBaseInfo.companyCreateTime }}</span>
              <!-- placeholder="格式:yyyy-MM-dd 例:1991-1-1"  -->
            </div>
            <div class="ayui_item">
              <label><i class="i-sign">∗</i> 统一社会信用代码 :</label>
              <span class="ayui-span">{{ siteBaseInfo.companyNumber }}</span>
            </div>
            <div class="ayui_item">
              <label>登记机关 :</label>
              <span class="ayui-span">{{ siteBaseInfo.registerOffice }}</span>
            </div>
            <div class="ayui_item">
              <label>申请工商单位:</label>
              <span class="ayui-span">{{ siteBaseInfo.orgName }}</span>
            </div>
            <div class="ayui_item">
              <label><i class="i-sign">∗</i> 类型 :</label>
              <span class="ayui-span">
	                 {{ siteBaseInfo.companyTypeStr }}
	                 </span>
            </div>
            <div class="ayui_item">
              <label> 营业期限:</label>
              <span class="ayui-span">{{ siteBaseInfo.operateTimeStart }}至{{ siteBaseInfo.operateTimeEnd }}</span>
            </div>
            <div class="ayui_item ayui_home">
              <label>住址 :</label>
              <span class="ayui-span">{{ siteBaseInfo.address }}</span>
            </div>
            <div class="ayui_item ayui_textarea" style="height:auto;">
              <label>经营范围 :</label>
              <span class="ayui-span">{{ siteBaseInfo.operateScope }}</span>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
        <div class="ay_userinfo">
          <div class="ayui_title">
            <span></span>网站基本情况
          </div>
          <div class="ayui_list">
            <div class="ayui_item" style="float:none;">
              <label><i class="i-sign">∗</i> 网站名称 :</label>
              <span class="ayui-span">{{ siteBaseInfo.siteName }}</span>
            </div>
            <div class="ayui_item" style="float:none;">
              <label><i class="i-sign">∗</i> 交易类型 :</label>
              <span class="ayui-span">{{ siteBaseInfo.dealTypeStr }}</span>
            </div>
            <div class="ayui_item" style="float:none;height:auto;">
              <label><i class="i-sign">∗</i> 网站域名 :</label>
              <div class="ayui-urlList" v-for="domain in siteBaseInfo.domainItems">{{ domain }}</div>
            </div>
            <div class="ayui_item" style="float:none;">
              <label><i class="i-sign">∗</i> 网站类型 :</label>
              <span class="ayui-span">{{ siteBaseInfo.siteTypeStr }}</span>
            </div>
            <div class="ayui_item ayui_textarea" style="height:auto;float:none; ">
              <label>网站说明 :</label>
              <span class="ayui-span">{{ siteBaseInfo.siteDescription }}</span>
            </div>
            <div style="clear: both;"></div>
          </div>

        </div>
        <div class="ay_userinfo ay_user">
          <div class="ayui_title">
            <span></span>申请人信息
          </div>
          <div class="ayui_list">
            <div class="ayui_item">
              <label><i class="i-sign">∗</i> 姓名 :</label>
              <span class="ayui-span">{{ siteBaseInfo.applyName }}</span>
            </div>
            <div class="ayui_item">
              <label><i class="i-sign">∗</i> 电话 :</label>
              <span class="ayui-span">{{ siteBaseInfo.applyPhone }}</span>
            </div>
            <div class="ayui_item">
              <label><i class="i-sign">∗</i> 邮箱 :</label>
              <span class="ayui-span">{{ siteBaseInfo.applyEmail }}</span>
            </div>
            <div style="clear: both;"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import navigation from './navigation'

export default {
  name: 'detailInfo',
  components: {
    'navigation': navigation
  },
  data() {
    return {
      siteBaseInfo: {
        siteTypeStr: null,
        domainItems: null,
        verCode: null,
        siteBaseId: null,
        companyName: null,
        companyLegalPerson: null,
        companyNumber: null,
        companyType: null,
        companyRegisterMoney: null,
        companyCreateTime: null,
        registerOffice: null,
        operateTimeStart: null,
        operateTimeEnd: null,
        address: null,
        operateScope: null,
        siteType: null,
        siteDomain: null,
        siteName: null,
        siteDescription: null,
        orgId: null,
        applyStatus: null,
        description: null,
        isOwned: null,
        ownerOrg: null,
        ownerOrgCode: null,
        dealType: null,
        applyPhone: null,
        applyName: null,
        clientUserId: null,
        applyEmail: null
      }
    }
  },
  watch: {
    $route: function (route) {
      this.dataList(this, 1)
    }
  },
  created: function () {
    this.getSiteBaseInfo(this.$route.params.siteBaseId)
  },
  methods: {
    getSiteBaseInfo(siteBaseId) {
      let _self = this
      _self.axios.get(
        _self.api.getSiteBaseInfoById + siteBaseId,
      ).then(res => {
        if (res.data.code === 10001) {
          this.toIndex()
        }
        this.siteBaseInfo = res.data.obj
      }).catch(err => {
        this.$message.error('网络请求异常!')
      })
    },
    toIndex() {
      this.$router.push({
        path: '/index'
      })
    }
  }
}
</script>

<style>
@import '../assets/css/aicUser.css';
@import '../assets/css/newStyle.css';
@import '../assets/css/highlight.css';
@import '../assets/css/paging.css';
@import '../assets/css/bright.css';

#applyStatus .li {
  background: rgba(0, 0, 0, 0) none repeat scroll !important;
}

</style>




// WEBPACK FOOTER //
// src/components/detailInfo.vue